// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3_yOv","label":"styles_label__c97Xr"};